import classNames from 'classnames';
import React from 'react';
import SVG from 'react-inlinesvg';

import Button, { ButtonStyles } from '@Components/Buttons/Button';
import Row from '@Components/layout/Row';
import Typography from '@Components/Typography';
import { FaqCategoryFragment } from '@Graphql/graphqlTypes.generated';

import styles from './FAQCategoriesContentItem.module.scss';

interface FAQCategoriesContentItemProps {
  category: FaqCategoryFragment;
  onClick: () => void;
  active: boolean;
}

const returnIcon = (icon: string) => (
  <div className={styles.icon}>
    <SVG src={icon} />
  </div>
);

const FAQCategoriesContentItem: React.FC<FAQCategoriesContentItemProps> = ({ category, onClick, active }) => {
  return (
    <li className={classNames(styles.faqCategoriesContainerItem, { [styles.active]: active })}>
      <Button onClick={onClick} style={ButtonStyles.plain} className={styles.categoryButton}>
        <Row constant alignCenter>
          {category.icon && returnIcon(category.icon)}
          <Typography msg={category.name} tag="span" className={styles.categoryName} size="m" />
        </Row>
      </Button>
    </li>
  );
};

export default FAQCategoriesContentItem;
